module.exports = __webpack_public_path__ + "assets/img/es-f141f308.png";